import React from 'react';

import { createClassName } from 'utils/createClassName';

import './paragraphStyles.scss';

type Props = {
  margin?: 'm' | 'l';
  align?: 'center';
};

export const ParagraphComponent: React.FC<Props> = (props) => {
  const { children, margin = 'm', align } = props;

  const className = createClassName('paragraph')({ margin, align });

  return <div className={className}>{children}</div>;
};
